<template>
  <div id="app">
    <!-- <appHeader></appHeader> -->
    <div class="mainContent">
      <keep-alive :exclude="excludeCache">
        <router-view/>
      </keep-alive>
    </div>
  </div>
</template>

<script>
// import appHeader from 'views/firmiana/home/head'
import appFooter from 'views/firmiana/home/footer'
import {mapGetters, mapActions} from 'vuex'
export default {
  name: 'App',
  components: {
    appFooter
  },
  data () {
    return {
      excludeCache: ['App'],
      timer: 0
    }
  },
  methods: {
    ...mapActions([
      'getMinHeight',
      'getMessageGlobal'
    ]),
    retryGetMessage () {
      this.timer = setTimeout(() => {
        this.getMessageGlobal({
          typeId: 0
        }).then((res) => {
          this.retryGetMessage()
        })
      }, 10 * 1000)
    },
    getHeight () {
      let h = window.innerHeight
      let minHeight = h - 140 + 'px'
      this.getMinHeight(minHeight)
    }
  },
  computed: {
    ...mapGetters([
      'primaryColor',
      'minHeight',
      'cachedViews',
      'token'
    ])
  },
  mounted () {
    this.getHeight()
    window.addEventListener('resize', this.getHeight)
  },
  destroyed () {
    window.removeEventListener('resize', this.getHeight)
    clearTimeout(this.timer)
  },
  watch: {
    cachedViews (val) {
      if (val.length <= 0 || !val.includes('appmetaPro')) {
        this.excludeCache = ['App', 'appLayout']
      } else {
        this.excludeCache = ['App']
      }
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss">
  @import 'styles/variable';
  html, body {
    height: 100%;
    overflow: hidden;
  }
  #app {
    height: 100%;
    .mainContent {
      height: 100%;
    }
    .el-dialog__header {
      background: lightgray;
    }
  }
  body .el-table colgroup.gutter{
    display: table-cell!important;
  }
  body .el-table th.gutter{
    display: table-cell!important;
  }
  body {
    background-color: #f0f0f0;
    // background: #fff url('/static/body-bg.png') top left repeat;
    // 骇客方法解决dialog页面跳动
    padding-right: 0px !important;
    .el-popover {
      min-width: 80px;
      text-align: center;
      .ASC:hover, .DESC:hover{
        background: rgba(0,0,0,.4);
        color: #fff;
      }
    }
    .compare_header {
      width: 100%;
      height: 40px;
      line-height: 40px;
      border-radius: 3px;
      color: #000;
      font-weight: 550;
      font-size: 14px;
      text-indent: 10px;
      background: lightgray;
    }
    .nameInnerDialog {
      .el-dialog__header {
        background: $metaTabHeaderBG;
        padding: 10px 20px 10px;
      }
      .el-dialog__title {
        color: #fff
      }
      .el-dialog__body {
        border: 3px solid $metaTabHeaderBG;
        border-top: none;
        padding: 10px 17px;
        font-size: 12px;
      }
      .el-dialog__headerbtn {
        top: 15px;
      }
      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
      }
      .info {
        display: inline-block;
        width: 100px;
        height: 14px;
        line-height:14px;
        font-weight:bold;
        text-align: left;
        margin-top: 10px;
      }
      .info_data {
        display: inline-block;
        height: 14px;
        line-height: 14px;
        margin-top: 10px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue